import { useState, useEffect, useRef, forwardRef, useImperativeHandle, useMemo } from 'react';

import { Select, Popover, InputNumber } from 'antd';

import SelectInputWrapper from './style';

const { Option } = Select;
// 库存输入框
const InputSelect = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    validate,
  }));

  const loop = () => {};

  const {
    defaultCount, // 默认数量
    defaultUnit, // 默认单位
    productUnit, // 基础单位
    productMinEncapsulationUnit, // 包装单位
    productMinEncapsulationNumber, // 包装数量
    minBuyNumber, // 最小起订量
    theRatio, // 拆分比例
    stockNumber,
    disabled,
    onChange = loop,
    onChangeUseInputCount,
  } = props;

  const [count, setCount] = useState('');
  const [unit, setUnit] = useState(defaultUnit);
  const [content, setContent] = useState('');
  const [open, setOpen] = useState(false);
  const inputRef = useRef();
  const [blackCount, setBlackCount] = useState(defaultCount);

  function unitChange(value) {
    setUnit(value);
    if (value === productUnit) {
      setBlackCount(minBuyNumber);
    } else if (value === productMinEncapsulationUnit) {
      if (productMinEncapsulationNumber >= minBuyNumber) {
        setBlackCount(1);
      } else {
        setBlackCount(Math.ceil(minBuyNumber / productMinEncapsulationNumber));
      }
    }
    if (count) {
      setCount(blackCount);
    }
  }

  const selectAfter = useMemo(
    () => (
      <Select
        className="_lg:w-[64px] w-[50px]"
        defaultValue={defaultUnit}
        onChange={unitChange}
        disabled={!productMinEncapsulationUnit}
        getPopupContainer={(triggerNode) => triggerNode}
        dropdownStyle={{
          zIndex: 2,
          padding: '0 1px',
          boxSizing: 'content-box',
        }}
      >
        {!!productUnit && <Option value={productUnit}>{productUnit}</Option>}
        {!!productMinEncapsulationUnit && (
          <Option value={productMinEncapsulationUnit}>{productMinEncapsulationUnit}</Option>
        )}
      </Select>
    ),
    [defaultUnit, productUnit, productMinEncapsulationUnit]
  );

  function validate(value, inputValue) {
    let realCount = value;
    let content = '';
    if (minBuyNumber && (realCount < minBuyNumber || realCount < 1 || isNaN(realCount))) {
      content = `最小起订量为${minBuyNumber}，已为您修正购买数量`;
      realCount = minBuyNumber;
    }
    if (theRatio && realCount % theRatio !== 0) {
      content = `不符合递增量，已为您修正购买数量`;
      realCount = theRatio * Math.ceil(realCount / theRatio);
    }
    if (stockNumber !== null) {
      if (stockNumber < minBuyNumber) {
        content = `当前商品不可超库存购买`;
        realCount = minBuyNumber;
      } else if (realCount > stockNumber) {
        content = `当前商品不可超库存购买, 已为您修正`;
        realCount = theRatio * Math.floor(stockNumber / theRatio);
      }
    }
    if (unit === productMinEncapsulationUnit) {
      realCount = Math.ceil(realCount / productMinEncapsulationNumber);
    }
    if (content) {
      setContent(content);
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
      }, 3000);
      setCount(realCount);
    }
    // 给询价弹窗进行赋值 如果为空 则不赋值 否则 正常赋值
    typeof onChangeUseInputCount === 'function' &&
      onChangeUseInputCount(!inputValue && inputValue !== 0 ? '' : realCount);
    return content === '';
  }

  function inputBlur(value) {
    let realCount = value || blackCount;
    if (unit === productMinEncapsulationUnit) {
      realCount *= productMinEncapsulationNumber;
    }
    validate(realCount, value);
  }

  function inputKeyUp(event) {
    if (event.key === 'Enter') {
      inputRef.current.blur();
    }
  }

  useEffect(() => {
    let realCount = count || blackCount;
    if (unit === productMinEncapsulationUnit) {
      realCount *= productMinEncapsulationNumber;
    }
    onChange(realCount);
  }, [count, unit, blackCount]);

  return (
    <Popover content={content} open={open}>
      <SelectInputWrapper>
        <InputNumber
          ref={inputRef}
          value={count}
          placeholder={blackCount}
          maxLength={9}
          className="block w-full"
          addonAfter={selectAfter}
          disabled={disabled}
          controls={false}
          onBlur={(event) => inputBlur(event?.target?.value)}
          onChange={(value) => {
            setCount(value);
          }}
          onKeyUp={(event) => inputKeyUp(event)}
        ></InputNumber>
      </SelectInputWrapper>
    </Popover>
  );
});

InputSelect.displayName = 'InputSelect';

export default InputSelect;
